module.exports = __webpack_public_path__ + "static/media/upload-light.45b578ac.svg";